import { render } from "./PageLoader.vue?vue&type=template&id=61a0631f&scoped=true"
const script = {}

import "./PageLoader.vue?vue&type=style&index=0&id=61a0631f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a0631f"]])

export default __exports__